import  request from '@/utils/request-utils'
import { appConfig } from '@/config/app-config';
const evnUrl = appConfig.domain.httpUrl
export * from './enum'


/**
 * get 请求 查询企业列表
 * @param formData
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getBusinessListService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/system/company/list?name='+params.name+'&contactNumber='+params.contactNumber+'&status='+params.status+'&size='+params.displayNumber+'&page='+params.currentPage))
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * get 请求 查询模型列表
 * @param formData
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getModelListService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/system/aiModel/list?name='+params.name+'&size='+params.displayNumber+'&page='+params.currentPage))
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}

/**
 * post 请求 添加企业
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const addBusinessService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/company/add'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 添加模型
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const addModelService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/aiModel/add'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 修改模型
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const updateModelService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/aiModel/update'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 修改企业
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const updateBusinessService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/company/update'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 删除模型
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const delModelService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/aiModel/del'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 修改状态
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const statusBusinessService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/company/update/status'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 开启关闭ai问答
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const aiEnableBusinessService = async (params) => {
    try {
        const { data } = await request.postJson(evnUrl.concat('/system/company/aiEnable'),params)
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * post 请求 批量下载ai模型资料
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getFileAiModelDownLoadService = async (params) => {
    try {
        const { data } = await request.postDownLoad(evnUrl.concat('/system/aiModel/download'),params,'login')
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
/**
 * get 请求 获取权限数据
 * @param url
 * @param params
 * @returns {Promise<*>}
 */
export const getModelListAllService = async (params) => {
    try {
        const { data } = await request.get(evnUrl.concat('/system/company/model?companyId='+params.companyId))
        return data
    } catch (error) {
        return Promise.reject(error)
    }
}
